$(document).ready(function () {
  /* Collection List Slider */
  $(".popup_btns").click(function () {
    $(this).parents(".sc_collection_slider").addClass("popup");

    var vals = $(this).parents(".slider").attr("data");
    var mascaraUrl = "/products/" + vals + ".js";
    var outerHtml = $(this)
      .closest(".collection_slide_box")
      .find(".jdgm-widget")
      .prop("outerHTML");
    $(".pro_review").html(outerHtml);
    var variant = $(this)
      .parents(".collection_box")
      .find(".product-variant")
      .html();
    $(".popup_details .variant_data").html(variant);

    var pro_price = $(this).find(".price").text();
    jQuery.getJSON(mascaraUrl, function (product) {
      $(
        ".popup_products .variant_data .product-form__input label:nth-child(3)"
      ).click();
      //var pro_price = (product.price).toFixed(2);
      if (product.variants) {
        product.variants.forEach(function (variant) {
          if (variant.metafields && variant.metafields.custom) {
            var variantColorCode = variant.metafields.custom.variant_color_code;
          }
        });
      }
      $(".popup_products .popup__content .popup_details .product_title").text(
        product.title
      );
      $(".popup_products .popup__content .popup_details img").attr(
        "src",
        product.featured_image
      );
      $(".popup_products .product_price").text(pro_price);
      $(".popup_products .compare_price del").text(product.compare_at_price);
      $(".popup_products .money_guarantee .product_url").attr(
        "href",
        product.url
      );
      $(".popup_products .jdgm-widget").attr("data-id", product.id);
      $('.popup_products .popup_btn_bundle input[name="id"]').val(
        product.variants[0].id
      );

      // Check if variants exist
      if (product.variants && product.variants.length > 1) {
        product.variants.forEach(function (variant) {
          function toTitleCase(str) {
            return str.toLowerCase().split(" ").join("-");
          }
          var originalString = variant.title;
          var hyphenString = toTitleCase(originalString);
          var input_id = "forinput-label-" + hyphenString;
          var label = $("<label>")
            .attr({ for: input_id, "data-val": variant.id })
            .text(variant.title);
          var input = $("<input>").attr({
            type: "radio",
            name: "id",
            id: input_id,
            value: variant.id,
          });

          $(".variant_data label").click(function () {
            var data_title = $(this).data("variant-title");
            $(this)
              .closest(".product-form__input")
              .find('[data-variant-title="' + data_title + '"]')
              .addClass("active")
              .siblings()
              .removeClass("active");

            var var_label = $(this)
              .closest(".product-form__input")
              .find('[data-variant-title="' + data_title + '"]')
              .addClass("active")
              .attr("data-variant-title");
            console.log(var_label);

            var variant_val =
              $(this).find(".color_bg").data("variant_id") ||
              $(this).find(".variant_id").data("variant_id");
            $('.popup_btn_bundle input[name="id"]').val(variant_val);
            var prices = $(this)
              .parents(".variant_data")
              .find('#variant-select option[value="' + variant_val + '"]')
              .attr("data-price");
            $(this)
              .parents(".popup__content")
              .find(".popup_btn_bundle .product_price")
              .text(prices);

            var activeBlock_data = [];
            $(
              ".sc_collection_slider.popup .variant_data .variant-name-label.active"
            ).each(function () {
              var vals = $(this).attr("data-variant-title");
              console.log("hello" + vals);
              activeBlock_data.push(vals);
            });
            var mergedval = activeBlock_data.join("-");

            var pro_val = $(this)
              .parents(".popup__content")
              .find("#variant-select")
              .find('option[data-title="' + mergedval + '"]')
              .val();
            $(
              '.sc_collection_slider.popup .popup_btn_bundle input[name="id"]'
            ).val(pro_val);

            var pro_price = $(this)
              .parents(".popup__content")
              .find("#variant-select")
              .find('option[data-title="' + mergedval + '"]')
              .attr("data-price");
            $(".sc_collection_slider.popup .product_price").text(pro_price);
            var img_url = $(this)
              .parents(".popup__content")
              .find("#variant-select")
              .find('option[data-title="' + mergedval + '"]')
              .attr("img-src");
            $(".sc_collection_slider.popup .popup_details img").attr(
              "src",
              img_url
            );
          });
        });
      }
    });
    var pro_title = $(this).parents(".collection_slide_box").find("h4").text();
    var pro_img = $(this)
      .parents(".collection_slide_box")
      .find("img")
      .attr("src");
    $(this)
      .parents(".sc_collection_slider")
      .find(".popup_products")
      .fadeIn(500);
    $("body").addClass("popup_open");
  });

  $(".popup_closes").click(function () {
    $(".sc_collection_slider").removeClass("popup");
    closePopup();
  });
  function closePopup() {
    $(".popup_products").fadeOut(500);
    $("body").removeClass("popup_open");
  }

  $("body").click(function (e) {
    if (
      !$(e.target).closest(".popup__content").length &&
      !$(e.target).closest(".btn.popup_btns").length &&
      !$(e.target).closest(".product-form__input").length
    ) {
      $(".sc_collection_slider").removeClass("popup");
      $(".popup_products").fadeOut(500);
      $("body").removeClass("popup_open");
    }
  });

  /* Add To Cart */
  $(".best_seller_data").click(function () {
    var vals = $(this)
      .parents(".popup__content")
      .find('.popup_btn_bundle input[name="id"]')
      .val();
    var qty = 1;
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id: vals, quantity: qty },
      dataType: "json",
      success: function () {
        $("cart-drawer").removeClass("is-empty");
        $(".drawer__inner-empty").hide();
        $("cart-drawer").load(location.href + " #CartDrawer");
        $(".cart_item_clear_btn").addClass("active");
        setTimeout(function () {
          $(".cart_item_clear_btn").addClass("active");
          $(".drawer").addClass("active animate");
        }, 1000);
        jQuery.getJSON("/cart.js", function (cart) {
          if (cart.item_count > 0) {
            $(".header__icon .cart-count-bubble span:first-child").text(
              cart.item_count
            );
          }
        });
      },
      error: function () {
        console.log("not add");
      },
    });
  });

  /* review-video-slider */
  $(".add_to_carts").click(function () {
    $(this).parents(".review_video_slider").addClass("popup");
    var vals = $(this).parents(".vb_pro_info_wrapper").attr("data");
    var mascaraUrl = "/products/" + vals + ".js";
    var variant = $(this)
      .parents(".vb_pro_info_wrapper")
      .find(".product-variant")
      .html();
    $(".popup_details .variant_data").html(variant);
    var outerHtml = $(this)
      .closest(".vb_product_box")
      .find(".jdgm-widget")
      .prop("outerHTML");
    $(".pro_review").html(outerHtml);

    var prices = $(this)
      .closest(".vb_product_wrapper")
      .find(".vb_pro_pricing span")
      .text();
    $(".popup_btn_bundle .product_price").text(prices);

    jQuery.getJSON(mascaraUrl, function (product) {
      var pro_url = product.url;
      console.log("assss" + pro_url);
      $(
        ".popup_products_bundle .variant_data .product-form__input label:nth-child(3)"
      ).click();
      $(".popup_products_bundle .popup_details img").attr(
        "src",
        product.featured_image
      );
      $(".popup_products_bundle .product_title").text(product.title);
      // $(".popup_products_bundle .product_price").text("$" + product.price);
      $(".popup_products_bundle .compare_price del").text(
        product.compare_at_price
      );
      $(".popup_products_bundle .money_guarantee p .product_url").attr(
        "href",
        pro_url
      );
      $('.popup_products_bundle .popup_btn_bundle input[name="id"]').val(
        product.variants[0].id
      );

      if (product.available == true) {
        $(".popup_products_bundle .best_seller_data").show();
        $(".popup_products_bundle .sold-out").hide();
      } else {
        $(".popup_products_bundle .best_seller_data").hide();
        $(".popup_products_bundle .sold-out").show();
      }

      if (product.variants && product.variants.length > 1) {
        product.variants.forEach(function (variant) {
          function toTitleCase(str) {
            return str.toLowerCase().split(" ").join("-");
          }

          var originalString = variant.title;
          var hyphenString = toTitleCase(originalString);
          var input_id = "forinput-label-" + hyphenString;

          var label = $("<label>")
            .attr({ for: input_id, "data-val": variant.id })
            .text(variant.title);

          var input = $("<input>").attr({
            type: "radio",
            name: "id",
            id: input_id,
            value: variant.id,
          });
        });
      }
    });
    $(".popup_products_bundle").fadeIn(500);
    $("body").addClass("popup_open_video");
  });

  $("body").click(function (e) {
    if (
      !$(e.target).closest(".popup__content").length &&
      !$(e.target).closest(".add_to_carts").length &&
      !$(e.target).closest(".product-form__input").length
    ) {
      $(".review_video_slider").removeClass("popup");
      $(".popup_products_bundle").fadeOut(500);
      $("body").removeClass("popup_open_video");
    }
  });

  $(".popup_closes").click(function () {
    $(".review_video_slider").removeClass("popup");
    $(".popup_products_bundle").fadeOut(500);
    $("body").removeClass("popup_open_video");
  });

  $(".best_seller_data").click(function (e) {
    e.preventDefault();
    var vals = $(this)
      .parents(".popup_btn_bundle")
      .find('input[name="id"]')
      .val();
    var qty = 1;

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id: vals, quantity: qty },
      dataType: "json",
      success: function () {
        $("cart-drawer").removeClass("is-empty");
        $(".drawer__inner-empty").hide();
        $("cart-drawer").load(location.href + " #CartDrawer");
        $(".cart_item_clear_btn").addClass("active");
        setTimeout(function () {
          $(".cart_item_clear_btn").addClass("active");
          $(".drawer").addClass("active animate");
        }, 1000);
        jQuery.getJSON("/cart.js", function (cart) {
          if (cart.item_count > 0) {
            $(".header__icon .cart-count-bubble span:first-child").text(
              cart.item_count
            );
          }
        });
      },
      error: function () {
        console.log("not add");
      },
    });
  });

  /* shop-the-look-section */

  $(document).on("click", function (event) {
    if (!$(event.target).closest(".hotspot").length) {
      $(".hotspot").removeClass("active");
    }
  });
  $(function () {
    $(".hotspot").click(function () {
      $(".hotspot").removeClass("active");
      $(this).addClass("active");
    });

    $(".popup_btn").click(function () {
      console.log("aa");
      setTimeout(function () {
        $(
          ".popup_product .variant_data .product-form__input label:nth-child(3)"
        ).click();
      }, 100);

      var variant = $(this)
        .parents(".product_details")
        .find(".product-variant")
        .html();
      $(".popup_product .variant_data").html(variant);
      $(".popup_product .variant_data label").click(function () {
        var data_title = $(this).data("variant-title");
        $(this)
          .closest(".product-form__input")
          .find('[data-variant-title="' + data_title + '"]')
          .addClass("active")
          .siblings()
          .removeClass("active");
        var variant_val =
          $(this).find(".color_bg").data("variant_id") ||
          $(this).find(".variant_id").data("variant_id");
        $('.popup_btn input[name="id"]').val(variant_val);
        var activeBlocks = [];
        $(".popup_product .popup__content .variant-name-label.active").each(
          function () {
            var activeBlock = $(this).data("variant-title");
            activeBlocks.push(activeBlock);
          }
        );
        var mergedValue = activeBlocks.join("-");
        $(".popup_product .popup__content .popup-variant-append option").each(
          function () {
            var op_data_title = $(this).data("title");
            if (mergedValue == op_data_title) {
              var var_id_ = $(this).val();
              $('.popup_btn input[name="id"]').val(var_id_);
            }
          }
        );
      });

      $(".popup_product").fadeIn(500);
      $("body").addClass("popup_open_shop");
      $("body").on("click.closePopup", function (e) {
        if (
          !$(e.target).closest(".popup__content").length &&
          !$(e.target).closest(".popup_btn").length &&
          !$(e.target).closest(".product-form__input").length
        ) {
          $(".popup_product").fadeOut(500);
          $("body").removeClass("popup_open_shop");
        }
      });
    });

    $(".popup_close").click(function () {
      $(".popup_product").fadeOut(500);
      $("body").removeClass("popup_open_shop");
    });

    $(".product_quickview .product-form__input label").click(function () {
      $(".product-form__input input").prop("checked", false);
      $(this).prev("input").prop("checked", true);
      var var_id = $(".product-form__input input:checked").attr("id");
    });

    $(".popup_btn_cart.add_to_cart").click(function () {
      var ids = $(this).parents(".popup_btn").find('input[name="id"]').val();
      var qty = 1;
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { id: ids, quantity: qty },
        dataType: "json",
        success: function () {
          $("cart-drawer").removeClass("is-empty");
          $(".drawer__inner-empty").hide();
          $("cart-drawer").load(location.href + " #CartDrawer");
          $(".cart_item_clear_btn").addClass("active");
          setTimeout(function () {
            $(".cart_item_clear_btn").addClass("active");
            $(".drawer").addClass("active animate");
          }, 1000);
          jQuery.getJSON("/cart.js", function (cart) {
            if (cart.item_count > 0) {
              console.log(cart.item_count);
              $(".header__icon .cart-count-bubble span:first-child").text(
                cart.item_count
              );
            }
          });
        },
        error: function () {
          console.log("not add");
        },
      });
    });
    $(".label_datas").each(function () {
      $(this).find('input[type="radio"]').first().prop("checked", true);
    });
    var selectedValues = [];
    $(".label_datas").each(function () {
      $(this)
        .find("input:checked")
        .each(function () {
          selectedValues.push($(this).val());
        });
    });

    var combinedValue = selectedValues.join(" / ");
    var $option = $("select#variant-select").find(
      'option[data-title="' + combinedValue + '"]'
    );

    if ($option.length > 0) {
      $("select#variant-select").val($option.val()).trigger("change");
    }
    var vals = $("#variant-select option:selected").val();
    $(".popup_btn").find('input[name="id"]').val(vals);

    $(".label_datas input").change(function () {
      var selectedValues = [];
      $(".label_datas").each(function () {
        $(this)
          .find("input:checked")
          .each(function () {
            selectedValues.push($(this).val());
          });
      });

      var combinedValue = selectedValues.join(" / ");
      var $option = $("select#variant-select").find(
        'option[data-title="' + combinedValue + '"]'
      );

      if ($option.length > 0) {
        $("select#variant-select").val($option.val()).trigger("change");
      }

      var vals = $("#variant-select option:selected").val();
      $(".popup_btn").find('input[name="id"]').val(vals);
    });
  });

  /* main-blog */
  var blog_main = new Swiper(".rumi_blog_row", {
    navigation: {
      nextEl: ".blog-button-next",
      prevEl: ".blog-button-prev",
    },
    slidesPerView: 3.5,
    paginationClickable: true,
    spaceBetween: 30,
    breakpoints: {
      1440: {
        slidesPerView: 2.5,
      },
      1200: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 1,
      },
    },
  });

  /* main-blog */
  const duplicates = document.querySelectorAll(
    ".blogbox.swiper-slide-duplicate, .blogbox.hidden"
  );
  duplicates.forEach((element) => element.remove());

  // Initialize Swiper
  new Swiper(".blogdetails", {
    navigation: {
      nextEl: ".blogdetail-button-next",
      prevEl: ".blogdetail-button-prev",
    },
    slidesPerView: 3.5,
    paginationClickable: true,
    spaceBetween: 30,
    breakpoints: {
      1440: {
        slidesPerView: 2.5,
      },
      1200: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 1,
      },
    },
  });

  var swiper_logo = new Swiper('.swiper-5', {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 10,
      speed:4000,
      autoplay: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
   });


  /* cart Drawer removeClass Hidden */
   $('cart-drawer.drawer').removeClass('hidden');

});

